import React, { useMemo, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, ChevronDownIcon, EyeIcon, EditIcon, Trash2Icon, CheckCircleIcon, XCircleIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { ModalDialog } from '../components/ui/ModalDialog';
import { useIsMobile } from '../hooks/useMediaQuery';
import { useRole } from '../hooks/useRole';
export interface Patient {
  id: string;
  nome: string;
  cognome: string;
  telefono: string;
  email: string;
  indirizzo: string;
  codiceFiscale: string;
}
export const mockPatients: Patient[] = [{
  id: 'PAT-001',
  nome: 'Marco',
  cognome: 'Rossi',
  telefono: '+39 333 1234567',
  email: 'marco.rossi@email.it',
  indirizzo: 'Via Roma 12, 20121 Milano',
  codiceFiscale: 'RSSMRC80A01H501Z'
}, {
  id: 'PAT-002',
  nome: 'Giulia',
  cognome: 'Bianchi',
  telefono: '+39 334 2345678',
  email: 'giulia.bianchi@email.it',
  indirizzo: 'Corso Venezia 45, 20121 Milano',
  codiceFiscale: 'BNCGLI85B42F205X'
}, {
  id: 'PAT-003',
  nome: 'Luca',
  cognome: 'Romano',
  telefono: '+39 335 3456789',
  email: 'luca.romano@email.it',
  indirizzo: 'Via Dante 8, 00184 Roma',
  codiceFiscale: 'RMNLCU75C15D612Y'
}, {
  id: 'PAT-004',
  nome: 'Elena',
  cognome: 'Colombo',
  telefono: '+39 336 4567890',
  email: 'elena.colombo@email.it',
  indirizzo: 'Piazza Garibaldi 3, 80100 Napoli',
  codiceFiscale: 'CLMLNE90D50F205W'
}, {
  id: 'PAT-005',
  nome: 'Alessandro',
  cognome: 'Ricci',
  telefono: '+39 337 5678901',
  email: 'alessandro.ricci@email.it',
  indirizzo: 'Via Verdi 22, 10121 Torino',
  codiceFiscale: 'RCCLSS82E12H501V'
}, {
  id: 'PAT-006',
  nome: 'Anna',
  cognome: 'Ferrari',
  telefono: '+39 338 6789012',
  email: 'anna.ferrari@email.it',
  indirizzo: 'Via Mazzini 15, 40123 Bologna',
  codiceFiscale: 'FRRNNA88F45F205U'
}, {
  id: 'PAT-007',
  nome: 'Giuseppe',
  cognome: 'Russo',
  telefono: '+39 339 7890123',
  email: 'giuseppe.russo@email.it',
  indirizzo: 'Corso Umberto I 50, 90138 Napoli',
  codiceFiscale: 'RSSGPP70G18H501T'
}, {
  id: 'PAT-008',
  nome: 'Maria',
  cognome: 'Conti',
  telefono: '+39 340 8901234',
  email: 'maria.conti@email.it',
  indirizzo: 'Via Cavour 7, 50123 Firenze',
  codiceFiscale: 'CNTMRA79H52F205S'
}, {
  id: 'PAT-009',
  nome: 'Luigi',
  cognome: 'Gallo',
  telefono: '+39 341 9012345',
  email: 'luigi.gallo@email.it',
  indirizzo: 'Via Garibaldi 10, 16122 Genova',
  codiceFiscale: 'GLLLGU85I14H501R'
}, {
  id: 'PAT-010',
  nome: 'Francesca',
  cognome: 'Moretti',
  telefono: '+39 342 0123456',
  email: 'f.moretti@email.it',
  indirizzo: 'Viale XX Settembre 33, 34125 Trieste',
  codiceFiscale: 'MRTFNC92L60F205Q'
}, {
  id: 'PAT-011',
  nome: 'Roberto',
  cognome: 'Colombo',
  telefono: '+39 343 1234567',
  email: 'r.colombo@email.it',
  indirizzo: 'Via Manzoni 19, 20121 Milano',
  codiceFiscale: 'CLMRRT78M22H501P'
}, {
  id: 'PAT-012',
  nome: 'Chiara',
  cognome: 'Rizzo',
  telefono: '+39 344 2345678',
  email: 'c.rizzo@email.it',
  indirizzo: 'Via Petrarca 5, 00185 Roma',
  codiceFiscale: 'RZZCHR86N48F205O'
}, {
  id: 'PAT-013',
  nome: 'Davide',
  cognome: 'Fontana',
  telefono: '+39 345 3456789',
  email: 'd.fontana@email.it',
  indirizzo: 'Corso Vittorio Emanuele 100, 80121 Napoli',
  codiceFiscale: 'FNTDVD81P10H501N'
}, {
  id: 'PAT-014',
  nome: 'Sara',
  cognome: 'Lombardi',
  telefono: '+39 346 4567890',
  email: 's.lombardi@email.it',
  indirizzo: 'Via Leopardi 14, 10123 Torino',
  codiceFiscale: 'LMBSRA90Q55F205M'
}, {
  id: 'PAT-015',
  nome: 'Andrea',
  cognome: 'Barbieri',
  telefono: '+39 347 5678901',
  email: 'a.barbieri@email.it',
  indirizzo: 'Via San Vitale 40, 40125 Bologna',
  codiceFiscale: 'BRBNDR75R25H501L'
}];
function TruncatedCell({
  text
}: {
  text: string;
}) {
  const [show, setShow] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);
  const isMobileView = useIsMobile();
  const handleMouseEnter = () => {
    if (isMobileView) return;
    if (textRef.current) {
      if (textRef.current.scrollWidth > textRef.current.clientWidth) {
        setShow(true);
      }
    }
  };
  return <div className="relative min-w-0" onMouseEnter={handleMouseEnter} onMouseLeave={() => setShow(false)} data-id="element-1949">
      <span ref={textRef} className="block truncate" data-id="element-1950">
        {text}
      </span>
      {show && !isMobileView && <div className="fixed px-2.5 py-1.5 bg-text-primary text-white text-xs rounded-md whitespace-nowrap pointer-events-none shadow-lg" style={{
      zIndex: 9999,
      transform: 'translateY(-100%) translateY(-6px)'
    }} ref={el => {
      if (el) {
        const parent = el.parentElement?.getBoundingClientRect();
        if (parent) {
          el.style.top = `${parent.top}px`;
          el.style.left = `${parent.left}px`;
        }
      }
    }} data-id="element-1951">
          {text}
        </div>}
    </div>;
}
export function Patients() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const {
    role
  } = useRole();
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState<Patient[]>(mockPatients);
  const [deleteTarget, setDeleteTarget] = useState<Patient | null>(null);
  const [toastMessage, setToastMessage] = useState<{
    type: 'success' | 'error';
    text: string;
  } | null>(null);
  const itemsPerPage = 10;
  const showToast = (type: 'success' | 'error', text: string) => {
    setToastMessage({
      type,
      text
    });
    setTimeout(() => setToastMessage(null), 4000);
  };
  const handleDelete = () => {
    if (!deleteTarget) return;
    const newPatients = patients.filter(p => p.id !== deleteTarget.id);
    setPatients(newPatients);
    showToast('success', `Paziente ${deleteTarget.nome} ${deleteTarget.cognome} eliminato.`);
    setDeleteTarget(null);
    // Adjust current page if needed after deletion
    const newFilteredCount = newPatients.filter(p => {
      if (!searchQuery.trim()) return true;
      const q = searchQuery.toLowerCase();
      return p.nome.toLowerCase().includes(q) || p.cognome.toLowerCase().includes(q) || p.email.toLowerCase().includes(q) || p.telefono.toLowerCase().includes(q) || p.codiceFiscale.toLowerCase().includes(q);
    }).length;
    const newTotalPages = Math.ceil(newFilteredCount / itemsPerPage);
    if (currentPage > newTotalPages && newTotalPages > 0) {
      setCurrentPage(newTotalPages);
    }
  };
  const dashboardPatients = useMemo(() => {
    if (role === 'medico') {
      const verdiPatients = ['Marco', 'Elena', 'Francesca', 'Lorenzo', 'Chiara', 'Valentina', 'Davide', 'Maria', 'Giuseppe', 'Luigi', 'Roberto', 'Sara', 'Andrea', 'Stefano', 'Giulia'];
      return patients.filter(p => verdiPatients.includes(p.nome));
    }
    return patients;
  }, [role, patients]);
  const filteredPatients = useMemo(() => {
    let result = [...dashboardPatients];
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(p => p.nome.toLowerCase().includes(q) || p.cognome.toLowerCase().includes(q) || p.email.toLowerCase().includes(q) || p.telefono.toLowerCase().includes(q) || p.codiceFiscale.toLowerCase().includes(q));
    }
    return result;
  }, [searchQuery, dashboardPatients]);
  const totalPages = Math.ceil(filteredPatients.length / itemsPerPage);
  const paginatedPatients = filteredPatients.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  return <div className="space-y-6 w-full min-w-0 pb-12" data-id="element-1952">
      {/* Header */}
      <div data-id="element-1953">
        <h1 className="text-2xl md:text-page-title mb-1 md:mb-2 text-text-primary font-bold" data-id="element-1954">
          Pazienti
        </h1>
        <p className="text-sm md:text-body text-text-secondary" data-id="element-1955">
          Anagrafica pazienti e storico clinico
        </p>
      </div>

      {/* Filters */}
      <div className="flex flex-col md:flex-row gap-3 md:items-center bg-white p-4 rounded-medical-lg shadow-sm border border-clinical-gray-100" data-id="element-1956">
        <div className="relative w-full md:w-96" data-id="element-1957">
          <SearchIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-tertiary pointer-events-none" data-id="element-1958" />
          <input type="text" value={searchQuery} onChange={e => {
          setSearchQuery(e.target.value);
          setCurrentPage(1);
        }} placeholder="Cerca per nome, cognome, email, CF..." className="medical-input pl-9 text-sm h-9 w-full" data-id="element-1959" />
        </div>
      </div>

      {/* Table / Cards */}
      {!isMobile ? <div className="w-full max-w-full bg-white rounded-medical-lg shadow-card border border-clinical-gray-100" style={{
      overflowX: 'auto',
      overflowY: 'visible'
    }} data-id="element-1960">
          <table className="w-full text-left border-collapse" style={{
        tableLayout: 'fixed',
        minWidth: '950px'
      }} data-id="element-1961">
            <colgroup data-id="element-1962">
              <col style={{
            width: '12%'
          }} data-id="element-1963" />
              <col style={{
            width: '12%'
          }} data-id="element-1964" />
              <col style={{
            width: '14%'
          }} data-id="element-1965" />
              <col style={{
            width: '18%'
          }} data-id="element-1966" />
              <col style={{
            width: '18%'
          }} data-id="element-1967" />
              <col style={{
            width: '15%'
          }} data-id="element-1968" />
              <col style={{
            width: '11%'
          }} data-id="element-1969" />
            </colgroup>
            <thead data-id="element-1970">
              <tr className="bg-clinical-gray border-b border-clinical-gray-200" data-id="element-1971">
                <th className="px-4 py-3 text-table-header text-text-secondary whitespace-nowrap" data-id="element-1972">
                  Nome
                </th>
                <th className="px-4 py-3 text-table-header text-text-secondary whitespace-nowrap" data-id="element-1973">
                  Cognome
                </th>
                <th className="px-4 py-3 text-table-header text-text-secondary whitespace-nowrap" data-id="element-1974">
                  Telefono
                </th>
                <th className="px-4 py-3 text-table-header text-text-secondary whitespace-nowrap" data-id="element-1975">
                  Mail
                </th>
                <th className="px-4 py-3 text-table-header text-text-secondary whitespace-nowrap" data-id="element-1976">
                  Indirizzo
                </th>
                <th className="px-4 py-3 text-table-header text-text-secondary whitespace-nowrap" data-id="element-1977">
                  Codice Fiscale
                </th>
                <th className="px-4 py-3 text-table-header text-text-secondary whitespace-nowrap text-right" data-id="element-1978">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1979">
              {paginatedPatients.length === 0 ? <tr data-id="element-1980">
                  <td colSpan={7} className="px-4 py-8 text-center text-text-secondary text-body" data-id="element-1981">
                    Nessun paziente trovato.
                  </td>
                </tr> : paginatedPatients.map(patient => <tr key={patient.id} className="border-b border-clinical-gray-100 last:border-0 hover:bg-clinical-gray/30 transition-colors" data-id="element-1982">
                    <td className="px-4 py-3 text-body font-medium text-text-primary overflow-hidden" data-id="element-1983">
                      <TruncatedCell text={patient.nome} data-id="element-1984" />
                    </td>
                    <td className="px-4 py-3 text-body font-medium text-text-primary overflow-hidden" data-id="element-1985">
                      <TruncatedCell text={patient.cognome} data-id="element-1986" />
                    </td>
                    <td className="px-4 py-3 text-body text-text-secondary overflow-hidden" data-id="element-1987">
                      <TruncatedCell text={patient.telefono} data-id="element-1988" />
                    </td>
                    <td className="px-4 py-3 text-body text-text-secondary overflow-hidden" data-id="element-1989">
                      <TruncatedCell text={patient.email} data-id="element-1990" />
                    </td>
                    <td className="px-4 py-3 text-body text-text-secondary overflow-hidden" data-id="element-1991">
                      <TruncatedCell text={patient.indirizzo} data-id="element-1992" />
                    </td>
                    <td className="px-4 py-3 text-body text-text-secondary overflow-hidden" data-id="element-1993">
                      <TruncatedCell text={patient.codiceFiscale} data-id="element-1994" />
                    </td>
                    <td className="px-4 py-3" data-id="element-1995">
                      <div className="flex items-center justify-end gap-1" data-id="element-1996">
                        <div className="relative group/action" data-id="element-1997">
                          <button onClick={() => navigate(`/patients/${patient.id}`)} className="p-1.5 text-text-secondary hover:text-medical-green hover:bg-medical-green-50 rounded transition-colors" aria-label="Visualizza dettaglio paziente" data-id="element-1998">
                            <EyeIcon size={16} data-id="element-1999" />
                          </button>
                          <div className="fixed px-2 py-1 bg-text-primary text-white text-xs rounded whitespace-nowrap opacity-0 group-hover/action:opacity-100 transition-opacity pointer-events-none shadow-lg" style={{
                    zIndex: 9999
                  }} ref={el => {
                    if (el) {
                      const btn = el.previousElementSibling as HTMLElement;
                      if (btn) {
                        const rect = btn.getBoundingClientRect();
                        el.style.top = `${rect.top - el.offsetHeight - 6}px`;
                        el.style.left = `${rect.left + rect.width / 2 - el.offsetWidth / 2}px`;
                      }
                    }
                  }} data-id="element-2000">
                            Visualizza dettaglio
                          </div>
                        </div>
                        <div className="relative group/action" data-id="element-2001">
                          <button onClick={() => navigate(`/patients/${patient.id}?edit=true`)} className="p-1.5 text-text-secondary hover:text-medical-orange hover:bg-medical-orange-50 rounded transition-colors" aria-label="Modifica paziente" data-id="element-2002">
                            <EditIcon size={16} data-id="element-2003" />
                          </button>
                          <div className="fixed px-2 py-1 bg-text-primary text-white text-xs rounded whitespace-nowrap opacity-0 group-hover/action:opacity-100 transition-opacity pointer-events-none shadow-lg" style={{
                    zIndex: 9999
                  }} ref={el => {
                    if (el) {
                      const btn = el.previousElementSibling as HTMLElement;
                      if (btn) {
                        const rect = btn.getBoundingClientRect();
                        el.style.top = `${rect.top - el.offsetHeight - 6}px`;
                        el.style.left = `${rect.left + rect.width / 2 - el.offsetWidth / 2}px`;
                      }
                    }
                  }} data-id="element-2004">
                            Modifica paziente
                          </div>
                        </div>
                        <div className="relative group/action" data-id="element-2005">
                          <button onClick={() => setDeleteTarget(patient)} className="p-1.5 text-text-secondary hover:text-status-error hover:bg-status-error-bg rounded transition-colors" aria-label="Elimina paziente" data-id="element-2006">
                            <Trash2Icon size={16} data-id="element-2007" />
                          </button>
                          <div className="fixed px-2 py-1 bg-text-primary text-white text-xs rounded whitespace-nowrap opacity-0 group-hover/action:opacity-100 transition-opacity pointer-events-none shadow-lg" style={{
                    zIndex: 9999
                  }} ref={el => {
                    if (el) {
                      const btn = el.previousElementSibling as HTMLElement;
                      if (btn) {
                        const rect = btn.getBoundingClientRect();
                        el.style.top = `${rect.top - el.offsetHeight - 6}px`;
                        el.style.left = `${rect.left + rect.width / 2 - el.offsetWidth / 2}px`;
                      }
                    }
                  }} data-id="element-2008">
                            Elimina paziente
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div> : <div className="space-y-3" data-id="element-2009">
          {paginatedPatients.length === 0 ? <div className="p-6 text-center text-text-secondary text-body bg-white rounded-medical-lg shadow-card border border-clinical-gray-100" data-id="element-2010">
              Nessun paziente trovato.
            </div> : paginatedPatients.map(patient => <div key={patient.id} className="bg-white rounded-medical-lg shadow-card border border-clinical-gray-100 p-4 space-y-3" data-id="element-2011">
                <div className="min-w-0" data-id="element-2012">
                  <span className="text-sm font-medium text-text-primary truncate block" data-id="element-2013">
                    {patient.nome} {patient.cognome}
                  </span>
                  <span className="text-xs text-text-tertiary block mt-0.5" data-id="element-2014">
                    {patient.codiceFiscale}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-2" data-id="element-2015">
                  <div className="min-w-0" data-id="element-2016">
                    <span className="text-xs text-text-tertiary uppercase tracking-wider block mb-0.5" data-id="element-2017">
                      Telefono
                    </span>
                    <span className="text-sm text-text-secondary truncate block" data-id="element-2018">
                      {patient.telefono}
                    </span>
                  </div>
                  <div className="min-w-0" data-id="element-2019">
                    <span className="text-xs text-text-tertiary uppercase tracking-wider block mb-0.5" data-id="element-2020">
                      Mail
                    </span>
                    <span className="text-sm text-text-secondary truncate block" data-id="element-2021">
                      {patient.email}
                    </span>
                  </div>
                </div>
                <div className="pt-3 border-t border-clinical-gray-100 flex items-center gap-2 justify-between" data-id="element-2022">
                  <button onClick={() => navigate(`/patients/${patient.id}`)} className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-text-secondary hover:text-medical-green hover:bg-medical-green-50 rounded transition-colors min-h-[36px]" aria-label="Visualizza dettaglio paziente" data-id="element-2023">
                    <EyeIcon size={15} data-id="element-2024" /> Dettaglio
                  </button>
                  <button onClick={() => navigate(`/patients/${patient.id}?edit=true`)} className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-text-secondary hover:text-medical-orange hover:bg-medical-orange-50 rounded transition-colors min-h-[36px]" aria-label="Modifica paziente" data-id="element-2025">
                    <EditIcon size={15} data-id="element-2026" /> Modifica
                  </button>
                  <button onClick={() => setDeleteTarget(patient)} className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-text-secondary hover:text-status-error hover:bg-status-error-bg rounded transition-colors min-h-[36px]" aria-label="Elimina paziente" data-id="element-2027">
                    <Trash2Icon size={15} data-id="element-2028" /> Elimina
                  </button>
                </div>
              </div>)}
        </div>}

      {/* Pagination */}
      {totalPages > 1 && <div className="flex items-center justify-between px-1" data-id="element-2029">
          <span className="text-sm text-text-secondary" data-id="element-2030">
            {filteredPatients.length} risultati — Pagina {currentPage} di{' '}
            {totalPages}
          </span>
          <div className="flex items-center gap-2" data-id="element-2031">
            <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} className="w-8 h-8 flex items-center justify-center rounded border border-clinical-gray-200 text-text-secondary hover:bg-clinical-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-2032">
              <ChevronDownIcon size={16} className="rotate-90" data-id="element-2033" />
            </button>
            <div className="flex items-center gap-1" data-id="element-2034">
              {Array.from({
            length: totalPages
          }, (_, i) => i + 1).map(page => <button key={page} onClick={() => setCurrentPage(page)} className={`w-8 h-8 flex items-center justify-center rounded text-sm font-medium transition-colors ${currentPage === page ? 'bg-medical-green text-white border border-medical-green' : 'border border-clinical-gray-200 text-text-secondary hover:bg-clinical-gray-50'}`} data-id="element-2035">
                  {page}
                </button>)}
            </div>
            <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="w-8 h-8 flex items-center justify-center rounded border border-clinical-gray-200 text-text-secondary hover:bg-clinical-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-2036">
              <ChevronDownIcon size={16} className="-rotate-90" data-id="element-2037" />
            </button>
          </div>
        </div>}

      {/* Delete Confirmation Modal */}
      <ModalDialog isOpen={!!deleteTarget} onClose={() => setDeleteTarget(null)} title="Elimina Paziente" footer={<>
            <button className="medical-btn-secondary w-full sm:w-auto" onClick={() => setDeleteTarget(null)} data-id="element-2039">
              Annulla
            </button>
            <button className="medical-btn-primary w-full sm:w-auto bg-status-error hover:bg-status-error/90 border-status-error" onClick={handleDelete} data-id="element-2040">
              <Trash2Icon size={16} className="mr-1.5" data-id="element-2041" /> Conferma eliminazione
            </button>
          </>} data-id="element-2038">
        {deleteTarget && <div className="space-y-4" data-id="element-2042">
            <p className="text-sm text-text-secondary" data-id="element-2043">
              Sei sicuro di voler eliminare il paziente{' '}
              <span className="font-semibold text-text-primary" data-id="element-2044">
                {deleteTarget.nome} {deleteTarget.cognome}
              </span>
              ?
            </p>
            <div className="bg-status-error-bg border border-status-error/20 rounded-medical-lg p-4" data-id="element-2045">
              <p className="text-sm text-status-error font-medium" data-id="element-2046">
                Attenzione: questa operazione eliminerà anche tutto lo storico
                clinico e i referti associati al paziente. L'operazione non può
                essere annullata.
              </p>
            </div>
          </div>}
      </ModalDialog>

      {/* Toast */}
      <AnimatePresence data-id="element-2047">
        {toastMessage && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className={`fixed bottom-4 left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 sm:right-6 sm:bottom-6 z-50 flex items-center gap-3 px-4 py-3 rounded-medical-lg shadow-modal border bg-white w-[calc(100%-2rem)] max-w-[calc(100%-2rem)] sm:w-auto sm:max-w-md ${toastMessage.type === 'success' ? 'border-status-success/20' : 'border-status-error/20'}`} data-id="element-2048">
            {toastMessage.type === 'success' ? <CheckCircleIcon className="text-status-success shrink-0" size={20} data-id="element-2049" /> : <XCircleIcon className="text-status-error shrink-0" size={20} data-id="element-2050" />}
            <span className="text-sm font-medium text-text-primary" data-id="element-2051">
              {toastMessage.text}
            </span>
            <button onClick={() => setToastMessage(null)} className="ml-2 p-1 text-text-tertiary hover:text-text-primary rounded-full transition-colors" data-id="element-2052">
              <XIcon size={16} data-id="element-2053" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}